/**
 * Yearn v3 `BaseStrategy` limit view — the strategy-defined hook behind
 * `maxWithdraw` (`maxWithdraw(owner)` is
 * `min(availableWithdrawLimit(owner), convertToAssets(balanceOf(owner)))`).
 *
 * Called with a **neutral probe address** that holds no shares and has
 * no protocol state, it returns the vault's *global* withdrawable
 * liquidity this block — which is exactly what `maxWithdraw` can never
 * surface (it clamps to the owner's balance, so any probe address reads
 * `0`).
 *
 * Used by 3Jane's USD3, whose limit is real multi-source liquidity
 * (idle USDC + waEthUSDC redeemable through its MorphoCredit market,
 * capped by the Aave pool's own liquidity) rather than a token balance
 * — which is why the `erc4626-idle` reader's `balanceOf(inventory)`
 * read cannot model it.
 */
export const AvailableWithdrawLimitAbi = [
  {
    name: 'availableWithdrawLimit',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address', name: 'owner' }],
    outputs: [{ type: 'uint256' }],
  },
] as const
